import React, { useEffect, useRef } from 'react';
import { useRouter } from '@/Framework/Router';
import Select from '@/finsight/ui/common/components/Select';
import { useLeagueTableContext } from '@/finsight/application/League/Table/LeagueTableContext';
import useReduxSelector from '@/Framework/hooks/useReduxSelector';
import { useLeagueTableFiltersContext } from '@/finsight/application/League/Table/LeagueTableFiltersContext';

interface IReduxProps {
  includedProductIds: string[],
  includedRegionIds: string[],
}

export const stateSelector = (state):IReduxProps => ({
  includedProductIds: state.pageFilters.productIds,
  includedRegionIds: state.pageFilters.regionIds,
});

const TTMSelect = (props) => {
  const { query: { products, regions } } = useRouter();
  const didMount = useRef(false);
  const { paginateTopRatingAgencies } = useLeagueTableContext();
  const {
    state: filtersState,
    getTopRatingAgenciesPeriods,
    resetTopRatingAgenciesPeriod,
    setTopRatingAgenciesPeriod,
  } = useLeagueTableFiltersContext();

  const selectedPeriod = filtersState.periods.topRatingAgencies.selected;
  const periodsCollection = filtersState.periods.topRatingAgencies.collection;

  const {
    includedProductIds,
    includedRegionIds,
  } = useReduxSelector<IReduxProps>(stateSelector);

  const onChangeSelectedOption = (value) => {
    setTopRatingAgenciesPeriod(value);
    paginateTopRatingAgencies(1);
  };

  useEffect(() => () => {
    resetTopRatingAgenciesPeriod();
  }, []);

  useEffect(() => {
    if (didMount.current) {
      getTopRatingAgenciesPeriods({ includedProductIds, includedRegionIds });
    } else {
      didMount.current = true;
    }
  }, [products, regions]);

  return (
    <Select
      { ...props }
      name="topRatingAgenciesTTMFilter"
      selectedOption={ selectedPeriod }
      options={ periodsCollection }
      tooltipContent="Change Period"
      tooltipPlacement="top"
      onChangeSelectedOption={ onChangeSelectedOption }
    />
  );
};

export default TTMSelect;
